const state = {
  customerId: localStorage.getItem('customer_id') || null
};

const mutations = {
  SET_CUSTOMER_ID(state, id) {
    state.customerId = id;
    localStorage.setItem('customer_id', id);
  }
};

const actions = {
  initializeCustomerId({ commit, state }) {
    if (!state.customerId) {
      const id = 'CUS_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      commit('SET_CUSTOMER_ID', id);
    }
    return state.customerId;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};